"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var THREE = __importStar(require("../../../externals/three"));
var GLOBAL_UTILS = __importStar(require("../../../shared/util/GlobalUtils"));
var SHADERS = __importStar(require("../shaders/ShaderFile"));
var MaterialHandlerHelpers_1 = __importDefault(require("../helpers/handlers/MaterialHandlerHelpers"));
var MaterialHandlerInsance = /** @class */ (function () {
    // #endregion Properties (18)
    // #region Constructors (1)
    function MaterialHandlerInsance(settings, _handlers) {
        var _this = this;
        this._handlers = _handlers;
        // #region Properties (18)
        this._envMapFilenames = ['px', 'nx', 'pz', 'nz', 'py', 'ny'];
        this._envMapNamesJPG = [
            'default',
            'default_bw',
            'blurred_lights',
            'georgentor',
            'georgentor_blur',
            'georgentor_blue_blur',
            'georgentor_bw_blur',
            'levelsets',
            'lythwood_field',
            'mountains',
            'ocean',
            'piazza_san_marco',
            'residential_garden',
            'room_abstract_1',
            'sky',
            'storage_room',
            'storm',
            'subway_entrance',
            'subway_entrance_bw_blur',
            'white',
            'yokohama',
        ];
        this._envMapNamesPNG = [];
        this._envMapUrlPrefix = 'https://viewer.shapediver.com/v2/envmaps/';
        this._gemSphericalMaps = {};
        this._textureUnitCount = 0;
        this._usedEnvironmentMaps = [];
        this._active = true;
        this._environmentMap = null;
        this._lightFrustum = 6.5;
        this._lightWorldSize = 0.005;
        this._mipmapBlackListed = false;
        this._sceneBackground = null;
        this._settings = settings.settings;
        this._pathUtils = settings.pathUtils;
        this._scene = settings.scene;
        this._helpers = new MaterialHandlerHelpers_1.default(_handlers, {
            nameStandard: 'ShapeDiverStandardMaterial',
            nameSimple: 'MeshPhongMaterial'
        });
        if (!_handlers.renderingHandler._getExtension('EXT_shader_texture_lod'))
            this._mipmapBlackListed = true;
        this._textureUnitCount = _handlers.renderingHandler._getTextureUnitCount();
        this._settings.registerHook('environmentMap', function (name) { return _this.environmentMapHook(name); });
        this._settings.updateSettingAsync('environmentMap', this._settings.getSetting('environmentMap'));
        this._settings.registerHook('environmentMapAsBackground', this.environmentMapAsBackgroundHook.bind(this));
        this._settings.registerHook('environmentMapResolution', this.environmentMapResolutionHook.bind(this));
    }
    // #endregion Constructors (1)
    // #region Public Methods (11)
    /** @inheritdoc */
    MaterialHandlerInsance.prototype.adjustToBoundingSphere = function (bs) {
        this._lightWorldSize = bs.radius / 25.0 * .005;
        this._lightFrustum = bs.radius / 25.0 * 6.5;
        var materials = this._handlers.threeDManager.helpers.getMaterials();
        for (var i = 0, len = materials.length; i < len; i++) {
            var mat = materials[i];
            if (mat.type == 'ShapeDiverStandardMaterial') {
                mat.lightWorldSize = this._lightWorldSize;
                mat.lightFrustum = this._lightFrustum;
            }
        }
    };
    /** @inheritdoc */
    MaterialHandlerInsance.prototype.compile = function () {
        this._handlers.beautyRenderHandler.renderHidden();
        this._helpers.checkMaterials();
    };
    MaterialHandlerInsance.prototype.createCubeNormalMap = function (geometryObject, version, resolution) {
        var path = this.getTransformationPath(geometryObject) + version;
        if (this._gemSphericalMaps[path + '_' + resolution])
            return this._gemSphericalMaps[path + '_' + resolution];
        var _gemScene = new THREE.Scene();
        var _gemCubeCamera = new THREE.CubeCamera(0.001, 10000, resolution);
        _gemCubeCamera.renderTarget.texture.generateMipmaps = false;
        _gemCubeCamera.renderTarget.texture.minFilter = THREE.NearestFilter;
        _gemCubeCamera.renderTarget.texture.magFilter = THREE.NearestFilter;
        _gemCubeCamera.renderTarget.texture.format = THREE.RGBAFormat;
        _gemScene.add(_gemCubeCamera);
        if (!this._gemNormalMaterial) {
            var _normalShader = {
                defines: {
                    STANDARD: '',
                },
                uniforms: THREE.UniformsUtils.merge([
                    THREE.UniformsLib.common,
                    {
                        emissive: { value: new THREE.Color(0x000000) },
                        roughness: { value: 0.5 },
                        metalness: { value: 0 },
                        envMapIntensity: { value: 1 },
                    }
                ]),
                vertexShader: SHADERS.normal_vert,
                fragmentShader: SHADERS.normal_frag
            };
            this._gemNormalMaterial = new THREE.ShaderMaterial({
                uniforms: THREE.UniformsUtils.clone(_normalShader.uniforms),
                defines: _normalShader.defines,
                vertexShader: _normalShader.vertexShader,
                fragmentShader: _normalShader.fragmentShader
            });
            this._gemNormalMaterial.blending = THREE.NoBlending;
            this._gemNormalMaterial.side = THREE.DoubleSide;
            _gemScene.overrideMaterial = this._gemNormalMaterial;
        }
        var mesh = new THREE.Mesh(geometryObject.geometry.clone(), this._gemNormalMaterial);
        mesh.geometry.center();
        _gemScene.add(mesh);
        _gemCubeCamera.update(this._handlers.renderingHandler.getRenderer(), _gemScene);
        _gemScene.remove(mesh);
        this._gemSphericalMaps[path + '_' + resolution] = _gemCubeCamera.renderTarget.texture;
        return this._gemSphericalMaps[path + '_' + resolution];
    };
    /** @inheritdoc */
    MaterialHandlerInsance.prototype.destroy = function () {
        // destroy the material handler
    };
    /** @inheritdoc */
    MaterialHandlerInsance.prototype.getEnvironmentMap = function () {
        return this._environmentMap;
    };
    MaterialHandlerInsance.prototype.getMaterial = function (properties, geometryObject, version, overrideColor, vertexColors) {
        if (properties == null)
            properties = {};
        var mat;
        if (!properties.attributes) {
            if (geometryObject && geometryObject.geometry && geometryObject.geometry.attributes) {
                properties.attributes = Object.keys(geometryObject.geometry.attributes);
            }
        }
        if (properties.materialType === 'gem') {
            var sphericalNormalMap = this.createCubeNormalMap(geometryObject, version, properties.resolution);
            if (!geometryObject.geometry.boundingSphere)
                geometryObject.geometry.computeBoundingSphere();
            var center = geometryObject.geometry.boundingSphere.center, radius = geometryObject.geometry.boundingSphere.radius;
            properties.side = THREE.FrontSide;
            properties = Object.assign({
                inverseModelMatrix: new THREE.Matrix4().getInverse(geometryObject.matrixWorld),
                inverseTransposeModelMatrix: new THREE.Matrix3().getNormalMatrix(new THREE.Matrix4().getInverse(geometryObject.matrixWorld).transpose()),
                center: center,
                radius: radius,
                sphericalNormalMap: sphericalNormalMap,
                envMap: properties.environmentMap ? properties.environmentMap : this._environmentMap,
                customEnvMap: !!properties.environmentMap
            }, properties);
            mat = new THREE.ShapeDiverGemMaterial(properties);
        }
        else {
            mat = new THREE.ShapeDiverStandardMaterial(Object.assign({ textureUnitCount: this._textureUnitCount, lightWorldSize: this._lightWorldSize, lightFrustum: this._lightFrustum, envMap: this._environmentMap, renderAO: true }, properties));
            if (overrideColor)
                mat.color.set(overrideColor.toRgbString());
            if (vertexColors)
                mat.vertexColors = THREE.VertexColors;
            this._handlers.lightHandler.reevaluateNumberOfShadowMaps(mat.availableTextures);
        }
        return mat;
    };
    MaterialHandlerInsance.prototype.getSceneBackground = function () {
        return this._sceneBackground;
    };
    MaterialHandlerInsance.prototype.getSimpleMaterial = function (properties) {
        return new THREE.MeshPhongMaterial(Object.assign({ shininess: properties.metalness ? properties.metalness * 128.0 : 0.0 }, properties));
    };
    MaterialHandlerInsance.prototype.pause = function () {
        this._active = false;
    };
    MaterialHandlerInsance.prototype.resume = function () {
        this._active = true;
    };
    MaterialHandlerInsance.prototype.setSceneBackground = function (b) {
        this._sceneBackground = b;
    };
    // #endregion Public Methods (11)
    // #region Private Methods (6)
    /**
         * Assigns the enviornment map to the current selection.
         * Adds the environment map to the _scene.background, if activated.
         * Updates all materials.
         *
         * @param {Object} mapObject The environment map object with the name and the map
         */
    MaterialHandlerInsance.prototype.assignEnvironmentMap = function (mapObject) {
        if (this._settings.getSetting('environmentMapAsBackground'))
            this._sceneBackground = mapObject.map;
        var materials = this._handlers.threeDManager.helpers.getMaterials();
        for (var i = 0, len = materials.length; i < len; i++) {
            var mat = materials[i];
            if (mat.type == 'ShapeDiverStandardMaterial') {
                mat.envMap = mapObject.map;
                mat.needsUpdate = true;
            }
            else if (mat.type == 'ShapeDiverGemMaterial') {
                if (!mat.customEnvMap)
                    mat.envMap = mapObject.map;
            }
        }
        this._environmentMap = mapObject.map;
        this._handlers.renderingHandler.render();
    };
    /**
    * Toggles the environment map as background.
    *
    * @param {Boolean} toggle To what to set the mode
    * @returns {Boolean} If the mode was successfully set
    */
    MaterialHandlerInsance.prototype.environmentMapAsBackgroundHook = function (toggle) {
        var scope = 'MaterialHandler.Hook->environmentMapAsBackground';
        if (!GLOBAL_UTILS.typeCheck(toggle, 'boolean', this._handlers.threeDManager.warn, scope))
            return false;
        if (this._handlers.threeDManager.getSetting('groundPlaneReflectionVisibility') && toggle) {
            this._handlers.threeDManager.warn(scope, 'The ground plane reflection and the environment as background do not work together right now.');
            return false;
        }
        if (toggle) {
            this._sceneBackground = this._environmentMap;
        }
        else {
            this._sceneBackground = null;
        }
        this._handlers.renderingHandler.render();
        return true;
    };
    /**
     * Changes the environment by calling the appropriate function in ShapeDiverMaterialLoader.
     * The viewer will be set to busy while it is loading.
     *
     * @param  {String} name  Can be the name of a predefined environment map like
     *                        'default','default_bw','blurred_lights','georgentor','georgentor_blur','georgentor_blue_blur',
     *                        'georgentor_bw_blur','mountains','ocean','piazza_san_marco','room_abstract_1','sky',
     *                        'storm','subway_entrance','subway_entrance_bw_blur','white','yokohama'
     *                        or an array of urls ('px','nx','pz','nz','py','ny').
     * @returns {Promise<Boolean>} Returns a promise, which will resolve to true or false depending on success
     */
    MaterialHandlerInsance.prototype.environmentMapHook = function (name, _resolution) {
        return __awaiter(this, void 0, void 0, function () {
            var scope, name_internal, name_caching, url, name_orig, resolution, _a, _b, envMap, i, response, ex_1;
            var e_1, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        scope = 'MaterialHandler.setEnvironmentMap';
                        if (name === undefined) {
                            this._handlers.threeDManager.warn(scope, 'No input was provided, the environment map was not set.');
                            return [2 /*return*/, Promise.resolve(false)];
                        }
                        if (name === 'none') {
                            this.assignEnvironmentMap({
                                name: 'none',
                                map: null
                            });
                            return [2 /*return*/, Promise.resolve(true)];
                        }
                        // check if name is a JSON.stringified version of an array of urls
                        if (GLOBAL_UTILS.typeCheck(name, 'string') && name.startsWith('["https') && name.endsWith('"]')) {
                            name_orig = name;
                            try {
                                name = JSON.parse(name_orig);
                            }
                            catch (e) {
                                name = name_orig;
                            }
                        }
                        resolution = _resolution || this._settings.getSetting('environmentMapResolution');
                        // deal with string or array, define names for loading and caching
                        if (GLOBAL_UTILS.typeCheck(name, 'string')) {
                            name_internal = name.toLowerCase().replace(/ /g, '_');
                            name_caching = name_internal + resolution;
                        }
                        else if (Array.isArray(name)) {
                            url = name;
                            if (url.length !== 6) {
                                this._handlers.threeDManager.warn(scope, 'The number of URLs was not 6, the environment map was not set.');
                                return [2 /*return*/, Promise.resolve(false)];
                            }
                            name_internal = JSON.stringify(url, null, 0);
                            name_caching = name_internal;
                        }
                        try {
                            // check if environment map is already cached
                            for (_a = __values(this._usedEnvironmentMaps), _b = _a.next(); !_b.done; _b = _a.next()) {
                                envMap = _b.value;
                                if (envMap.name === name_caching) {
                                    this.assignEnvironmentMap(envMap);
                                    return [2 /*return*/, Promise.resolve(true)];
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        // define urls for 6 cube images ourselves
                        if (url === undefined) {
                            url = [];
                            i = void 0;
                            if (this._envMapNamesJPG.indexOf(name_internal) >= 0) {
                                // found in list of available environment maps with file type jpg
                                for (i = 0; i < this._envMapFilenames.length; i++)
                                    url.push(this._envMapUrlPrefix + resolution + '/' + name_internal + '/' + this._envMapFilenames[i] + '.jpg');
                            }
                            else if (this._envMapNamesPNG.indexOf(name_internal) >= 0) {
                                // found in list of available environment maps with file type png
                                for (i = 0; i < this._envMapFilenames.length; i++)
                                    url.push(this._envMapUrlPrefix + resolution + '/' + name_internal + '/' + this._envMapFilenames[i] + '.png');
                            }
                            else if (name.startsWith('https://') || name.startsWith('http://')) {
                                if (!name.endsWith('/')) {
                                    name += '/';
                                }
                                for (i = 0; i < this._envMapFilenames.length; i++)
                                    url.push(name + this._envMapFilenames[i] + '.jpg');
                            }
                            else {
                                if (name !== 'none')
                                    this._handlers.threeDManager.warn(scope, 'Environment map name not found, and not a base URL', name);
                                return [2 /*return*/, Promise.resolve(false)];
                            }
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.loadEnvironmentMap(name_caching, url)];
                    case 2:
                        response = _d.sent();
                        this._usedEnvironmentMaps.push(response);
                        this.assignEnvironmentMap(response);
                        return [2 /*return*/, Promise.resolve(true)];
                    case 3:
                        ex_1 = _d.sent();
                        this._handlers.threeDManager.warn(scope, 'Was not able to load the environment map, the environment map was not set.');
                        return [2 /*return*/, Promise.resolve(false)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Changes the resolution of the environment map.
     *
     * @param  {String} resolution  Currently supported resolutions: '256', '512', '1024', '2048'
     * @returns {Promise<Boolean>} Returns a promise, which will resolve to true or false depending on success
     */
    MaterialHandlerInsance.prototype.environmentMapResolutionHook = function (resolution) {
        var scope = 'MaterialHandler.setEnvironmentMapResolution';
        if (!['256', '512', '1024', '2048'].includes(resolution)) {
            this._handlers.threeDManager.warn(scope, 'No valid input was provided, the environment map was not changed.');
            return Promise.resolve(false);
        }
        // special case: if environmentMap is set to 'none', immediately accept the change of resolution
        var name = this._settings.getSetting('environmentMap');
        if (name === 'none')
            return Promise.resolve(true);
        return this.environmentMapHook(name, resolution);
    };
    MaterialHandlerInsance.prototype.getTransformationPath = function (mesh) {
        var fullPath = this._pathUtils.getObjectPath(mesh);
        return fullPath.substring(0, fullPath.indexOf('.', fullPath.indexOf('transformation_')));
    };
    /**
     * Tries to load an environment map with the given urls and returns a
     * promise with the environment map if it succeded.
     *
     * @param {String} name The name of the environment map
     * @param {String[]} url The urls for the environment map
     * @returns {Promise} Promise with the environment map and name if succeded
     */
    MaterialHandlerInsance.prototype.loadEnvironmentMap = function (name, url) {
        return new Promise(function (resolve, reject) {
            function loadDone(environmentMap) {
                environmentMap.format = THREE.RGBFormat;
                environmentMap.mapping = THREE.CubeReflectionMapping;
                // Deactivate generation of mip maps if the device is on the black list
                if (this._mipmapBlackListed) {
                    environmentMap.generateMipmaps = false;
                    environmentMap.minFilter = THREE.LinearFilter;
                    environmentMap.magFilter = THREE.LinearFilter;
                }
                resolve({
                    name: name,
                    map: environmentMap
                });
            }
            function error(xhr) {
                reject(xhr);
            }
            new THREE.CubeTextureLoader().load(url, loadDone, null, error);
        });
    };
    return MaterialHandlerInsance;
}());
var MaterialHandler = /** @class */ (function () {
    // #endregion Properties (1)
    // #region Constructors (1)
    function MaterialHandler(_settings, _handlers) {
        this._materialHandlerInstance = new MaterialHandlerInsance(_settings, _handlers);
    }
    // #endregion Constructors (1)
    // #region Public Methods (10)
    MaterialHandler.prototype.adjustToBoundingSphere = function (bs) {
        this._materialHandlerInstance.adjustToBoundingSphere(bs);
    };
    MaterialHandler.prototype.compile = function () {
        this._materialHandlerInstance.compile();
    };
    MaterialHandler.prototype.destroy = function () {
        this._materialHandlerInstance.destroy();
    };
    MaterialHandler.prototype.getEnvironmentMap = function () {
        return this._materialHandlerInstance.getEnvironmentMap();
    };
    MaterialHandler.prototype.getMaterial = function (properties, geometryObject, version, overrideColor, vertexColors) {
        return this._materialHandlerInstance.getMaterial(properties, geometryObject, version, overrideColor, vertexColors);
    };
    MaterialHandler.prototype.getSceneBackground = function () {
        return this._materialHandlerInstance.getSceneBackground();
    };
    MaterialHandler.prototype.getSimpleMaterial = function (properties) {
        return this._materialHandlerInstance.getSimpleMaterial(properties);
    };
    MaterialHandler.prototype.pause = function () {
        this._materialHandlerInstance.pause();
    };
    MaterialHandler.prototype.resume = function () {
        this._materialHandlerInstance.resume();
    };
    MaterialHandler.prototype.setSceneBackground = function (b) {
        this._materialHandlerInstance.setSceneBackground(b);
    };
    return MaterialHandler;
}());
exports.MaterialHandler = MaterialHandler;
